'use client'

import { useEffect } from "react";

export default function HeaderWidget({
  language = "en",
  iconColor,
  angelaiUrl,
  downloadButton = false,
  buttonLabel = "Ask Angel",
  ctaButtonLabel,
  hashKey,
  navLinkTextColor = "white",
  ctaBtnColor = "black",
  brandTaglineColor,
  angelButtonTextColor = "white",
  askAngelButton = false,
  investorRelations = true,
  angelTwinLogo = false,
  angelAiPage = false,
  navOrder = [],
  cdnBase,
  mountId = "angelai-header-widget",
  route,
}) {
  useEffect(() => {
    if (typeof document === "undefined") return;

    let mount = document.getElementById(mountId);
    if (!mount) {
      mount = document.createElement("div");
      mount.id = mountId;
      document.body.prepend(mount);
    }
    mount.setAttribute("data-language", language);
    if (route) mount.setAttribute("data-route", route);
    else mount.removeAttribute("data-route");
    if (iconColor) mount.setAttribute("data-icon-color", iconColor);
    else mount.removeAttribute("data-icon-color");
    mount.setAttribute("data-nav-link-text-color", navLinkTextColor);
    mount.setAttribute("data-cta-btn-color", ctaBtnColor);
    if (brandTaglineColor) mount.setAttribute("data-brand-tagline-color", brandTaglineColor);
    else mount.removeAttribute("data-brand-tagline-color");
    mount.setAttribute("data-angel-button-text-color", angelButtonTextColor);
    if (angelaiUrl) mount.setAttribute("data-angelai-url", angelaiUrl);
    else mount.removeAttribute("data-angelai-url");
    mount.setAttribute("data-download-button", downloadButton ? "true" : "false");
    mount.setAttribute("data-ask-angel-button", askAngelButton ? "true" : "false");
    mount.setAttribute("data-button-label", buttonLabel);
    if (ctaButtonLabel) mount.setAttribute("data-cta-button-label", ctaButtonLabel);
    else mount.removeAttribute("data-cta-button-label");
    if (hashKey) mount.setAttribute("data-hash-key", hashKey);
    else mount.removeAttribute("data-hash-key");
    mount.setAttribute("data-investor-relations", investorRelations ? "true" : "false");
    mount.setAttribute("data-angel-twin-logo", angelTwinLogo ? "true" : "false");
    mount.setAttribute("data-angelai-page", angelAiPage ? "true" : "false");
    if (navOrder && navOrder.length) mount.setAttribute("data-nav-order", navOrder.join(","));
    else mount.removeAttribute("data-nav-order");
    if (cdnBase) mount.setAttribute("data-cdn-base", cdnBase);

    if (typeof window.mountHeaderWidget === "function") window.mountHeaderWidget();
  }, [
    language, iconColor, angelaiUrl, downloadButton, buttonLabel, ctaButtonLabel, hashKey,
    navLinkTextColor, ctaBtnColor, brandTaglineColor, angelButtonTextColor,
    askAngelButton, investorRelations, angelTwinLogo, angelAiPage, navOrder,
    cdnBase, mountId, route,
  ]);

  return null;
}
